import React, { useEffect, useCallback, memo } from 'react';
import { X } from 'lucide-react';

import styles from './styles/Toast.module.css';

const Toast = ({ message, onClose, duration = 3000, type = 'info' }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const handleCloseClick = useCallback(e => {
        e.stopPropagation();
        onClose();
    }, [onClose]);

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            <div className={styles.toastContent}>
                {message}
            </div>
            <button 
                className={styles.closeButton} 
                onClick={handleCloseClick}
                aria-label="Close"
            >
                <X size={16} />
            </button>
        </div>
    );
};

export default memo(Toast);
